/* eslint-disable @typescript-eslint/no-explicit-any */
import { isNullOrUndefined, extend } from '@syncfusion/ej2-base';
import { getRecurrenceStringFromDate } from '../../recurrence-editor/date-generator';
/**
 * ICalendar Import Module
 */
export class ICalendarImport {
    constructor(parent) {
        this.allDay = false;
        this.parent = parent;
    }
    initializeCalendarImport(fileContent) {
        if (fileContent && fileContent instanceof Blob) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                const iCalString = fileReader.result;
                this.iCalendarParser(iCalString);
            };
            fileReader.readAsText(fileContent, 'UTF-8');
        }
        else if (fileContent && typeof fileContent === 'string') {
            this.iCalendarParser(fileContent);
        }
    }
    iCalendarParser(iCalString) {
        let iCalData = {
            isEvent: false,
            curEvent: null,
            id: this.parent.eventBase.getEventMaxID(),
            count: 0,
            events: [],
            key: null
        };
        const iStringLength = iCalString.length;
        let lastPosition = iCalString.search(/[^ \t]/);
        let position = lastPosition;
        let iString;
        let newlineOffset;
        do {
            position = iCalString.indexOf('\n', lastPosition) + 1;
            if (position === 0) {
                position = iStringLength;
                newlineOffset = 0;
            }
            else if (position > 1 && iCalString[position - 2] === '\r') {
                newlineOffset = 2;
            }
            else {
                newlineOffset = 1;
            }
            const firstChar = iCalString.charAt(lastPosition);
            if (firstChar === ' ' || firstChar === '\n' || firstChar === '\t') {
                iString += iCalString.slice(lastPosition + 1, position - newlineOffset);
            }
            else {
                if (iString) {
                    iCalData = this.updateEventData(iString, iCalData);
                }
                iString = iCalString.slice(lastPosition, position - newlineOffset);
            }
            lastPosition = position;
        } while (position !== iStringLength);
        iString = iString.trim();
        if (iString.length) {
            iCalData = this.updateEventData(iString, iCalData);
        }
        const app = extend([], iCalData.events, null, true);
        this.parent.addEvent(this.processOccurrence(app, iCalData.id));
    }
    updateEventData(iString, iCalData) {
        const fields = this.parent.eventFields;
        const SEPARATOR = '\r\n';
        const id = iCalData.id;
        const events = iCalData.events;
        let isEvent = iCalData.isEvent;
        let count = iCalData.count;
        let curEvent = iCalData.curEvent;
        let key = iCalData.key;
        if (!isEvent && iString === 'BEGIN:VEVENT') {
            isEvent = true;
            curEvent = {};
        }
        if (isEvent && iString === 'END:VEVENT') {
            isEvent = false;
            events.push(curEvent);
            curEvent = null;
        }
        if (isEvent) {
            const index = iString.indexOf(':');
            let type = iString.substring(0, index).replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            let value = iString.substring(index + 1, iString.length).replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            if (iString.indexOf('SUMMARY') !== -1) {
                type = 'SUMMARY';
            }
            if (iString.indexOf('DTSTART') !== -1) {
                curEvent[fields.startTime] = this.dateParsing(iString);
                curEvent[fields.isAllDay] = this.allDay;
                this.allDay = false;
            }
            else if (iString.indexOf('DTEND') !== -1) {
                curEvent[fields.endTime] = this.dateParsing(iString);
            }
            else if (iString.indexOf('EXDATE') !== -1) {
                value = getRecurrenceStringFromDate(this.dateParsing(iString));
                curEvent[fields.recurrenceException] = isNullOrUndefined(curEvent[fields.recurrenceException]) ?
                    value : curEvent[fields.recurrenceException] + ',' + value;
            }
            else if (iString.indexOf('RECURRENCE-ID') !== -1) {
                value = getRecurrenceStringFromDate(this.dateParsing(iString));
                curEvent[fields.recurrenceException] = value;
                curEvent[fields.recurrenceID] = value;
            }
            else {
                key = type || key;
                switch (key) {
                    case 'BEGIN':
                        break;
                    case 'UID':
                        curEvent[`${type}`] = value;
                        if (typeof (id) == 'number') {
                            curEvent[fields.id] = parseInt(value, 10);
                            if (isNaN(curEvent[fields.id])) {
                                curEvent[fields.id] = id + count;
                                count++;
                            }
                        }
                        else {
                            curEvent[fields.id] = value;
                        }
                        break;
                    case 'SUMMARY':
                        curEvent[fields.subject] = this.getFormattedString(value);
                        break;
                    case 'LOCATION':
                        curEvent[fields.location] = this.getFormattedString(value);
                        break;
                    case 'DESCRIPTION':
                        if (curEvent[fields.description]) {
                            curEvent[fields.description] = this.getFormattedString(curEvent[fields.description] + SEPARATOR + value);
                        }
                        else {
                            curEvent[fields.description] = this.getFormattedString(value);
                        }
                        break;
                    case 'ISREADONLY':
                        curEvent[fields.isReadonly] = (value.indexOf('true') > -1);
                        break;
                    case 'RRULE':
                        curEvent[fields.recurrenceRule] = value;
                        break;
                    default:
                        if (this.parent.resourceCollection.length > 0) {
                            const resData = this.parent.resourceCollection.filter((data) => data.field === type);
                            curEvent[`${type}`] = (resData.length > 0 && (typeof (resData[0].dataSource[0][resData[0].idField]) == 'number')) ? parseInt(value, 10) : value;
                        }
                        else {
                            curEvent[`${type}`] = value;
                        }
                }
            }
        }
        return { isEvent, curEvent, id, count, events, key };
    }
    processOccurrence(app, maxId) {
        const appoint = [];
        const uId = 'UID';
        const fields = this.parent.eventFields;
        const appointmentIds = [];
        this.parent.eventsData.forEach((eventObj) => {
            appointmentIds.push(eventObj[fields.id]);
        });
        app.forEach((eventObj) => {
            let parentObj;
            let id;
            // eslint-disable-next-line no-prototype-builtins
            if (!eventObj.hasOwnProperty(fields.recurrenceID)) {
                parentObj = eventObj;
                id = eventObj[fields.id];
            }
            if (appointmentIds.indexOf(eventObj[fields.id]) < 0) {
                const data = app.filter((data) => data.UID === eventObj[`${uId}`]);
                if (data.length > 1 && isNullOrUndefined(eventObj[fields.recurrenceID])) {
                    id = typeof (maxId) === 'number' ? maxId++ : id;
                    for (let i = 0; i < data.length; i++) {
                        // eslint-disable-next-line no-prototype-builtins
                        if (data[parseInt(i.toString(), 10)].hasOwnProperty(fields.recurrenceID)) {
                            const exdate = data[parseInt(i.toString(), 10)][fields.recurrenceID];
                            data[parseInt(i.toString(), 10)][fields.id] = typeof (maxId) === 'number' ? maxId++ : this.parent.eventBase.generateGuid();
                            data[parseInt(i.toString(), 10)][fields.recurrenceID] = id;
                            data[parseInt(i.toString(), 10)][fields.recurrenceException] = null;
                            parentObj[fields.recurrenceException] =
                                this.getExcludeDateString(parentObj[fields.recurrenceException], exdate);
                            delete data[parseInt(i.toString(), 10)][`${uId}`];
                            appoint.push(data[parseInt(i.toString(), 10)]);
                        }
                    }
                    delete parentObj[`${uId}`];
                    parentObj[fields.id] = id;
                    appoint.push(parentObj);
                    // eslint-disable-next-line no-prototype-builtins
                }
                else if (!eventObj.hasOwnProperty(fields.recurrenceID)) {
                    delete eventObj[`${uId}`];
                    eventObj[fields.id] = typeof (maxId) === 'number' ? maxId++ : id;
                    appoint.push(eventObj);
                }
            }
        });
        return appoint;
    }
    getExcludeDateString(parentException, occurrenceException) {
        if (isNullOrUndefined(parentException)) {
            return occurrenceException;
        }
        else if (isNullOrUndefined(occurrenceException)) {
            return parentException;
        }
        const parentExDate = parentException.split(',').map((x) => x.split('T')[0]);
        const childExDate = occurrenceException.split(',').map((x) => x.split('T')[0]);
        const exDate = parentExDate.filter((x) => childExDate.indexOf(x) > -1);
        if (exDate.length > 0) {
            return parentException;
        }
        return parentException + ',' + occurrenceException;
    }
    getFormattedString(value) {
        value = value || '';
        // eslint-disable-next-line no-useless-escape
        return (value.replace(/\\\,/g, ',').replace(/\\\;/g, ';').replace(/\\[nN]/g, '\n').replace(/\\\\/g, '\\'));
    }
    dateParsing(element) {
        const split = element.split(':');
        const value = split[split.length - 1];
        let newDate = new Date(this.getFormattedString(value));
        if (element && (element.indexOf('VALUE=DATE') > -1 || element.indexOf('RECURRENCE-ID;TZID') > -1)) {
            const data = /^(\d{4})(\d{2})(\d{2})$/.exec(value);
            if (data !== null) {
                newDate = new Date(parseInt(data[1], 10), parseInt(data[2], 10) - 1, parseInt(data[3], 10));
            }
            if (element.indexOf('DTSTART') > -1) {
                this.allDay = true;
            }
        }
        const data = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(Z)?$/.exec(value);
        if (data !== null) {
            if (data[7] === 'Z') {
                newDate = new Date(Date.UTC(parseInt(data[1], 10), parseInt(data[2], 10) - 1, parseInt(data[3], 10), parseInt(data[4], 10), parseInt(data[5], 10), parseInt(data[6], 10)));
            }
            else {
                newDate = new Date(parseInt(data[1], 10), parseInt(data[2], 10) - 1, parseInt(data[3], 10), parseInt(data[4], 10), parseInt(data[5], 10), parseInt(data[6], 10));
            }
        }
        return newDate;
    }
    getModuleName() {
        return 'iCalendarImport';
    }
    destroy() {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
    }
}
